export const fcmNotificationType = {
  addOrUpdateNotification: 'addOrUpdateNotification',
  externalLink: 'externalLink',
  internalLink: 'internalLink',
};
